// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__EH-IJ","box":"styles_box__gXWTq"};